"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMVDTOContract = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const TagDTOContract_1 = require("./TagDTOContract");
class EMVDTOContract {
}
exports.EMVDTOContract = EMVDTOContract;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => TagDTOContract_1.TagDTOContract),
    (0, class_transformer_1.Expose)()
], EMVDTOContract.prototype, "tags", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], EMVDTOContract.prototype, "applicationIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], EMVDTOContract.prototype, "applicationLabel", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], EMVDTOContract.prototype, "applicationPreferredName", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], EMVDTOContract.prototype, "applicationTransactionCounter", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], EMVDTOContract.prototype, "cryptogram", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], EMVDTOContract.prototype, "issuerCodeTableIndex", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], EMVDTOContract.prototype, "pinBypassed", void 0);
//# sourceMappingURL=EMVDTOPContract.js.map